import { useRouteMatch } from 'react-router';

import { SurveyRoute } from 'app/route';

export const useIsPreview = (): boolean => {
  return !!useRouteMatch(SurveyRoute.PREVIEW_PATTERN);
};
